export interface Country {
  countryCode: string;
  name: string;
  subdivisions: CountrySubdivision[];
}

export interface CountrySubdivision {
  countryCode: string;
  name: string;
  subdivisionCode: string;
}

export const defaultCountry: Country = {
  countryCode: "",
  name: "",
  subdivisions: [],
};

export const defaultCountrySubdivision: CountrySubdivision = {
  countryCode: "",
  name: "",
  subdivisionCode: "",
};

export const getCountryFromCode = (
  countryCode: string | undefined,
  countryList: Country[] | undefined
): Country | undefined => {
  if (countryCode && countryList && countryList.length > 0) {
    const country = countryList.find(
      (country) => country.countryCode === countryCode
    );
    if (country) {
      return country;
    }
  }
  return undefined;
};

export const getSubdivisionFromName = (
  subdivisionName: string | undefined,
  subdivisionList: CountrySubdivision[] | undefined
): CountrySubdivision | undefined => {
  if (subdivisionName && subdivisionList && subdivisionList.length > 0) {
    const subdivision = subdivisionList.find(
      (subdivision) => subdivision.name === subdivisionName
    );
    if (subdivision) {
      return subdivision;
    }
  }
  return undefined;
};

export const getSubdivisionsFromCountry = (
  country: Country | undefined,
  countryList: Country[] | undefined
): CountrySubdivision[] | undefined => {
  if (country?.subdivisions) {
    return country.subdivisions;
  }
  if (country && countryList && countryList.length > 0) {
    const selectedCountry = countryList.find(
      (c) => c.countryCode === country.countryCode
    );
    if (selectedCountry) {
      return selectedCountry.subdivisions;
    }
  }
  return undefined;
};
